import { Link } from "react-router-dom";
import { trackSeoPageEvent, SEO_ANALYTICS_EVENTS } from "../../../constants/seoAnalyticsConstants";

const GROUP_LABELS = {
  nearby_cities: "Ciudades cercanas",
  brands: "Marcas populares",
  models: "Modelos",
  body_types: "Por tipo",
  budget: "Por presupuesto",
  financing: "Financiación",
  transmission: "Transmisión",
  dealers: "Concesionarios",
  guides: "Guías para compradores",
};

export default function SeoInternalLinks({ links = [], title = "Búsquedas relacionadas" }) {
  if (!links.length) return null;

  const grouped = links.reduce((acc, link) => {
    const group = link.group || "other";
    if (!acc[group]) acc[group] = [];
    acc[group].push(link);
    return acc;
  }, {});

  return (
    <section className="seo-internal-links" aria-labelledby="seo-related-heading">
      <h2 id="seo-related-heading">{title}</h2>
      {Object.entries(grouped).map(([group, groupLinks]) => (
        <div key={group} className="seo-internal-links__group">
          {GROUP_LABELS[group] ? <h3>{GROUP_LABELS[group]}</h3> : null}
          <ul>
            {groupLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  onClick={() =>
                    trackSeoPageEvent(SEO_ANALYTICS_EVENTS.RELATED_LINK_CLICKED, {
                      href: link.href,
                      group,
                    })
                  }
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
}
